<template>
	<v-layout>
		<v-flex xs1 d-flex>
			<v-card :color='rowColor'>
				<v-card-text>
					<strong>
						{{1 + index + ' ' + (invoiceType || '')}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs2 d-flex>
			<v-card :color='rowColor'>
				<v-card-text>
					<strong>
						{{invoice.documentName}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs2 d-flex>
			<v-card :color='rowColor'>
				<v-card-text>
					<strong>
						{{invoice.documentNumber}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs1 d-flex>
			<v-card :color='rowColor'>
				<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
					<strong>
						{{formatMoney(invoice.totalValue)}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs2 d-flex>
			<v-card :color='rowColor'>
				<v-card-text style="text-align: center">
					<strong>
						{{invoice.documentDate}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs2 d-flex>
			<v-card :color='rowColor'>
				<v-card-text style="text-align: center">
					<strong v-if="invoice.paymentDates">
						{{invoice.paymentDates[0]}}
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs2 d-flex>
			<v-card :color='rowColor'>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
	import {Numbers} from "../../../utils/Numbers";
	import {InvoiceComparisonResult} from "./Utils/InvoiceComparisonResult";

	export default {
		name: "FinalReportInvoicesInvoiceGeneralDataRowComparison",

		computed: {
			rowColor () {
				switch (this.invoiceType) {
					case InvoiceComparisonResult.added:
						return 'green lighten-2';
					case InvoiceComparisonResult.removed:
						return 'red lighten-2';
					case InvoiceComparisonResult.changed:
						return 'blue lighten-2';
					case InvoiceComparisonResult.changedOldVersion:
						return 'blue lighten-2';
					case InvoiceComparisonResult.changedNewVersion:
						return 'blue lighten-2';
					default:
						return 'grey lighten-1';
				}
			}
		},

		props: {
			index: {},
			invoice: {},
			invoiceType: String
		},

		mixins: [Numbers]
	};
</script>

<style scoped>

</style>